<script>
  import {base_url, layers, layersInfo} from "./stores";

  //   export let layer_id, position, dimensions

  let url, layerInput, layerTypeVal = 'image', layerType, layerContent = '', layerImgUrl, layerTextContent;
</script>

<div class="layer">
  <div class="base-layer-options">
    <span>Base Layer Url</span>
    <input
            placeholder="default"
            bind:value={url}
            on:change={() => {
      base_url.set(url);
    }}
    />
  </div>
  <div class="add-layer">
    <span>Add Layer</span>
    <select bind:this={layerType} on:change={() => {
      layerTypeVal = layerType.value;
      if(layerImgUrl && layerTypeVal === 'image'){
        layerContent = layerImgUrl.value;
      }
    }}>
      <option value="image">Image</option>
      <option value="text">Text</option>
    </select>

    <textarea bind:this={layerTextContent}
              style="display: {layerTypeVal === 'text' ? 'block' : 'none'};"
              placeholder="Text"
              on:input={() => {
                  if(layerTypeVal === 'text'){
                      layerContent = layerTextContent.value;
                  }
              }}
    ></textarea>

    <input bind:this={layerImgUrl}
           style="display: {layerTypeVal === 'image' ? 'block' : 'none'};"
           placeholder="Image URL"
           on:input={() => {
               if(layerTypeVal === 'image'){
                 layerContent = layerImgUrl.value;
               }
           }}
    >
    <div class="layer-name">
      <input type="text" placeholder="Layer Name" bind:this={layerInput}>
      <button on:click={() => {

      let trimmedInput = layerInput.value.trim();
      if(trimmedInput === ''){
        return;
      }
      // Get user input and clean it so our regex works
      let layerName = trimmedInput.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      /*
      The regex below checks for the raw input plus that input followed by an integer in brackets. For example, if the input
      was "Hello World" it would match:
      Hello World
      Hello World (1)
      Hello World (2)
      etc...
      PS I hate regex and this took way to long to figure out
       */
      let dupes = $layers.filter(layerId => {return new RegExp(`^${layerName}( \\([0-9]+\\))?$`).test(layerId.name)});

      if(dupes.length > 0){
        // Calling replaceAll to remove the backlashes added to escape special characters in the input for the regex
        layerName = `${layerName.replaceAll('\\', '')} (${dupes.length})`;
      }
      $layers.push({name: layerName, type: layerTypeVal, content: layerContent});
      // This statement looks redundant but without it change detection will not pick up my changes
      $layers = $layers;
      console.log("Layers info: ", $layersInfo, "| Layers array", $layers);
      }}>Add</button>
    </div>
  </div>
  <div class="layers-listing">
    <h3>Layers:</h3>
    <ul>
      {#each $layers as layer}
        <li class="layer-listing">{layer.name} <button on:click={() => {
          $layers = $layers.filter(id => id !== layer);
          console.log(`deleted ${layer}`);
          console.log($layers);
        }
        }>Delete</button></li>
      {/each}
    </ul>
  </div>
</div>

<style>

  .layer {
    text-align: left;
    background-color: rgb(57, 62, 95);
    padding: 0.5rem;
    margin: 0.5rem;
    border-radius: 5px;
    color: white;
    height: 93%;
    display: flex;
    flex-direction: column;
  }

  .base-layer-options{

    flex: 0 1 auto;

  }

  .layer input {
    width: 100%;
  }

  .add-layer{

    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.5rem;
    flex-direction: column;

  }

  .add-layer > * {

    margin: 0 0 1rem;
    width: 100%;

  }

  .add-layer > span:first-child{

    margin-bottom: 0;

  }

  li{

    list-style-type: none;

  }

  .layers-listing{

    flex: 1 1 auto;
    max-height: 50%;

  }

  .layers-listing > h3:first-child{

    margin-top: 0;

  }

  .layers-listing ul{

    padding: 0;
    max-height: 17vw;
    overflow-y: auto;

  }

  .layer-listing{

    display: flex;

  }

  .layer-listing button{

    margin-left: auto;

  }

  .layer-name{

    display: flex;
    flex-direction: row;

  }

  .layer-name input{

    flex-basis: 75%;

  }

  .layer-name button{

    flex-basis: 25%;

  }

</style>
